import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";

interface NewsCardProps {
  article: NewsArticle;
}

export default function NewsCard({ article }: NewsCardProps) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative w-full h-[200px] overflow-hidden bg-background-100">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 糖心VLGO资讯`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
          {article.category}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line leading-none"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line leading-none"></i>
            {article.author}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
          {article.summary}
        </p>
        <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line leading-none transition-transform duration-300 group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}